const US_CODE = require("./uscode.json");
export { US_CODE };
